import React from 'react';
import { func, bool } from 'prop-types';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';
import Button from '../../shared/Button';
import FormButton from '../../forms/FormButton';

const FormButtons = ({ onCancel, disabled }) => {
  return (
    <div className={styles.formButtonsContainer}>
      <Button onClick={onCancel} variant="flat">
        {StringConstantsMixin.strings.CANCEL}
      </Button>
      | <FormButton className={styles.formButton} disabled={disabled} value={StringConstantsMixin.strings.SAVE} />
    </div>
  );
};

export default FormButtons;

FormButtons.propTypes = {
  onCancel: func.isRequired,
  disabled: bool
};

FormButtons.defaultProps = {
  disabled: false
};
